var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOutGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 37,
    viewBox: "0 0 80 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 5.5,
    width: 34,
    height: 23.9259,
    rx: 5,
    stroke: "#9CD0ED",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 14.3164H79",
    stroke: "#9CD0ED",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0352 24.168H55.0722",
    stroke: "#9CD0ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 25C3 24.1716 3.67157 23.5 4.5 23.5L32.5 23.5C33.3284 23.5 34 24.1716 34 25C34 25.8284 33.3284 26.5 32.5 26.5L4.5 26.5C3.67157 26.5 3 25.8284 3 25Z",
    fill: "#9CD0ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12C18 11.1716 18.6716 10.5 19.5 10.5L33.5 10.5C34.3284 10.5 35 11.1716 35 12C35 12.8284 34.3284 13.5 33.5 13.5L19.5 13.5C18.6716 13.5 18 12.8284 18 12Z",
    fill: "#9CD0ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2C20 1.17157 20.6716 0.5 21.5 0.5H41.5C42.3284 0.5 43 1.17157 43 2C43 2.82843 42.3284 3.5 41.5 3.5H21.5C20.6716 3.5 20 2.82843 20 2Z",
    fill: "#9CD0ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 35C22 34.1716 22.6716 33.5 23.5 33.5H43.5C44.3284 33.5 45 34.1716 45 35C45 35.8284 44.3284 36.5 43.5 36.5H23.5C22.6716 36.5 22 35.8284 22 35Z",
    fill: "#9CD0ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31134e-07 12C5.87108e-08 11.1716 0.671573 10.5 1.5 10.5L10.5 10.5C11.3284 10.5 12 11.1716 12 12C12 12.8284 11.3284 13.5 10.5 13.5L1.5 13.5C0.671573 13.5 2.03558e-07 12.8284 1.31134e-07 12Z",
    fill: "#9CD0ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutGuest);
export default __webpack_public_path__ + "static/media/CheckOutGuest.75c839792745894758a4e62fa4a3479c.svg";
export { ForwardRef as ReactComponent };